import React, { Fragment } from 'react';
import classNames from 'classnames';

import { GenericCondition } from './generic-condition';
import type { CommonRuleProps, ConditionsTranslations } from '../rule';
import type { Condition } from '../rule-utils';

interface RuleBodyProps extends CommonRuleProps {
	translations: ConditionsTranslations;
	conditions: Condition[];
	handleChange: (c: Condition, value: unknown) => void;
	removeCondition: (c: Condition) => void;
}

export const RuleBody = ({
	conditions,
	divider,
	parentContainerClass,
	removeCondition,
	handleChange,
	translations,
	contextSelector,
	disabled = false,
	maxAttributePathItems
}: RuleBodyProps) => {
	const conditionProps = {
		translations,
		parentContainerClass,
		removeCondition,
		handleChange,
		disabled,
		maxAttributePathItems
	};
	return (
		<div
			className={classNames('conditions-container', {
				'with-divider': Boolean(divider),
				[`${contextSelector}-container`]: Boolean(contextSelector)
			})}
		>
			{conditions.map((condition, index) => {
				// TODO: when memoization is settled
				//  investigate if / how storing a component to a variable affects memoization mechanism
				const element = (
					<GenericCondition key={condition.id} index={index} condition={condition} {...conditionProps} />
				);
				return divider && index < conditions.length - 1 ? (
					<Fragment key={condition.id}>
						{element}
						{divider}
					</Fragment>
				) : (
					element
				);
			})}
		</div>
	);
};
